import { FILE_SIZE_LIMIT } from "./constants";

export const mapUsersOptions = (users = []) => {
  return users.map(el => {
    return {
      ...el,
      name: el?.first_name ? `${el?.first_name} ${el?.last_name}` : el?.email
    };
  }) ?? [];
};

export const isFileSizeExceedsLimit = (files = []) => {
  return files.some(file => (file.size / (1024 * 1024)).toFixed(2) > FILE_SIZE_LIMIT);
};

export const formatDate = (date, time) => {
  const dateObj = new Date(date);
  const timeObj = new Date(time);
  const hours = timeObj.getHours();
  const minutes = timeObj.getMinutes();
  const seconds = timeObj.getSeconds();
  return new Date(dateObj.setHours(hours, minutes, seconds));
};
